import React from 'react'
import { string } from 'prop-types'
import { useSelector } from 'react-redux'
import { css } from '@emotion/react'

import SignUpButton from '@/components/Navigation/SignUpButton'
import useHydrationContext from '@/hooks/useHydrationContext'
import mediaQueries from '@/layout/media-queries'
import { isAuthorized } from '@/store/selectors'

import Apps from './Apps'
import Links from './Links'
import Icons from './Icons'
import Copyright from './Copyright'

const containerCss = (theme) => css`
  width: 100%;
  background-color: ${theme.colors.grey};
  padding: 0 40px;
  border-top: 1px solid ${theme.colors.iron};
`

const footerCss = (theme) => css`
  max-width: ${theme.maxWidth};
  margin: 0 auto;
  padding-top: 48px;
`

const signUpCss = css`
  font-weight: 500;
  margin-bottom: 24px;

  > span {
    margin-right: 25px;
    font-size: 16px;
  }
`

const mediaCss = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mediaQueries.smallScreen()} {
    flex-direction: row;
  }
`

const Footer = ({ className }) => {
  const isUserAuthorized = useSelector(isAuthorized)
  const hydrated = useHydrationContext()

  return (
    <footer className={className}>
      <div css={containerCss}>
        <div css={footerCss}>
          <Apps />
          <Links />
          <div css={mediaCss}>
            {!isUserAuthorized && hydrated && (
              <div css={signUpCss}>
                <span>Start your free trial</span>
                <SignUpButton />
              </div>
            )}
            <Icons />
          </div>
        </div>
      </div>
      <div css={containerCss}>
        <Copyright />
      </div>
    </footer>
  )
}

Footer.propTypes = {
  className: string,
}

export default Footer
